// @flow

import * as React from 'react';

import { webhosting } from '@gandi/cart';
import type { DecoratedProduct } from '@gandi/cart';

import { getPrice, useAvailableSizes } from '../modules/webhosting';

import { WebHostingPlanRows } from './WebHostingPlanRows';

export type Props = {
  product: DecoratedProduct,
  /** pass to `isBusy` a boolean that represent its business but `product.isWorking` */
  isBusy?: boolean,
  updateSizeHandler: (evt: SyntheticInputEvent<>) => Promise<void>,
  removeLowerThanActual?: boolean,
};

export function WebHostingSizeToggleGroupRow({
  product,
  isBusy = false,
  updateSizeHandler,
  removeLowerThanActual = false,
}: Props): React.MixedElement {
  /// size change
  const sizes = useAvailableSizes(
    product.payload.duration === 1 ? 'monthly' : 'yearly',
    product.payload.extra?.application,
  );

  // we may need to remove the lower choices
  let filteredSizes;
  const actualSize = webhosting.getActualSize(product.payload);
  if (sizes && removeLowerThanActual && actualSize) {
    const i = sizes.findIndex(s => s.value === actualSize);
    filteredSizes = sizes.slice(i + 1);
  }

  const options = filteredSizes || sizes;
  return (
    <WebHostingPlanRows
      key={sizes?.length}
      disabled={getPrice({ product, isBusy }) == null}
      onChange={updateSizeHandler}
      options={options}
      product={product}
    />
  );
}
